exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label[data-v-2835564a]{font-weight:700}.mt-20[data-v-2835564a]{margin-top:20px}.formulario[data-v-2835564a]{width:80%;margin:auto;background-color:#f8f9fa!important;min-height:100vh}.titulo[data-v-2835564a]{margin-top:20px;margin-bottom:6em}label.d-block[data-v-2835564a]{font-weight:700}.container[data-v-2835564a]{margin:0;background-color:#f8f9fa!important}.negrito[data-v-2835564a]{font-weight:700}.alert-info[data-v-2835564a]{background-color:transparent;border-color:transparent}.alert[data-v-2835564a]{padding:0}.dadosHistorico[data-v-2835564a]{background-color:#fff;padding-top:2em;padding-left:2em;padding-right:2em}@media (max-width:678px){.titulo[data-v-2835564a]{margin-bottom:0}.titulo h2[data-v-2835564a]{font-size:1.5rem}}.modal-body[data-v-2835564a]{white-space:break-spaces}.modal-content[data-v-2835564a]{width:fit-content!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2835564a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ConfirmaRequerimento.vue
// module id = 342
// module chunks = 0